import { Button, Paper, Typography, Link } from '@mui/material';
import { Link as LinkRouter } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

export default function AlreadyLoggedSendedPage() {
  const { t } = useTranslation();

  return (
    <Paper square elevation={3} sx={{ p: 5 }}>
      <Typography variant="h6" sx={{ mb: 4 }}>
        {t('already_logged:link_to_log_out_sent')}
      </Typography>
      <Typography sx={{ mb: 4 }}>
        {t('already_logged:to_complete_the_process_check_your_email_inbox')}
      </Typography>
      <Link to="/login" component={LinkRouter} sx={{ textDecoration: 'none' }}>
        <Button variant="outlined" fullWidth>
          {t('already_logged:back_to_login')}
        </Button>
      </Link>
    </Paper>
  );
}
